import { Resource } from '@opentelemetry/resources'
import { SemanticResourceAttributes } from '@opentelemetry/semantic-conventions'
import type { PeriodicExportingMetricReaderOptions } from '@opentelemetry/sdk-metrics'
import {
  ConsoleMetricExporter,
  MeterProvider,
  PeriodicExportingMetricReader,
} from '@opentelemetry/sdk-metrics'

interface ServiceOptions {
  name: string
  version: string
}

export interface MeterBaseProviderOptions {
  readerOptions: PeriodicExportingMetricReaderOptions
  service: ServiceOptions
}

const DEFAULT_INTERVAL_MS = 60_000
const DEFAULT_TIMEOUT_MS = 30_000

export const MeterBaseProvider = {
  create({
    readerOptions: {
      exporter,
      exportIntervalMillis = DEFAULT_INTERVAL_MS,
      exportTimeoutMillis = DEFAULT_TIMEOUT_MS,
    },
    service,
  }: MeterBaseProviderOptions) {
    const meterProvider = new MeterProvider({
      resource: Resource.default().merge(
        new Resource({
          [SemanticResourceAttributes.SERVICE_NAME]: service.name,
          [SemanticResourceAttributes.SERVICE_VERSION]: service.version,
        })
      ),
    })

    meterProvider.addMetricReader(
      new PeriodicExportingMetricReader({
        exporter,
        exportIntervalMillis,
        exportTimeoutMillis,
      })
    )

    const consoleExporter = new ConsoleMetricExporter()

    meterProvider.addMetricReader(
      new PeriodicExportingMetricReader({
        exporter: consoleExporter,
        exportIntervalMillis,
        exportTimeoutMillis,
      })
    )

    return meterProvider
  },
}
